<!-- ═══════════════ MODAL: STAKING LOCK ═══════════════ -->
@if (state.showStakingModal() && state.selectedStakedPool()) {
<div class="modal-overlay" (click)="state.closeStakingModal()">
  <div class="modal-panel animate-slide-up" (click)="$event.stopPropagation()">
    <button (click)="state.closeStakingModal()"
      class="absolute top-5.5 right-5.5 text-text-dim hover:text-white transition-colors text-lg">✕</button>

    <h3 class="font-display font-black text-2xl text-white tracking-wide mb-1">Stake Staking Pool</h3>
    <p class="text-[11.5px] text-text-dim uppercase tracking-wider font-semibold mb-5">Lock tokens in {{
      state.selectedStakedPool()?.name }}</p>

    <div class="grid grid-cols-2 gap-4 bg-white/[0.02] border border-border-primary rounded-2xl p-4.5 mb-5">
      <div>
        <p class="text-text-dim text-[10px] uppercase font-bold tracking-wider">Reward APR</p>
        <p class="font-display font-black text-2xl text-gold mt-1.5 leading-none">{{ state.selectedStakedPool()?.apr }}%</p>
      </div>
      <div>
        <p class="text-text-dim text-[10px] uppercase font-bold tracking-wider">Total Pool TVL</p>
        <p class="font-display font-black text-2xl text-white mt-1.5 leading-none">{{ state.selectedStakedPool()?.tvl }}</p>
      </div>
    </div>

    <div class="bg-black/45 border border-border-primary rounded-2xl p-4.5 mb-6">
      <div
        class="flex items-center justify-between text-[11px] font-bold text-text-dim uppercase tracking-wider mb-2">
        <span>Staking Lock Amount</span>
        <span>Available: {{ state.isWalletConnected() ? '1,000.00' : '--' }}</span>
      </div>
      <div class="flex items-center justify-between gap-4">
        <input type="text" placeholder="0.00" [value]="state.stakingAmountInput()"
          (input)="state.stakingAmountInput.set($any($event.target).value)" class="swap-input text-2xl" />
        <span class="font-black text-white text-[13.5px] tracking-widest uppercase">{{
          state.selectedStakedPool()?.tokenSymbol }}</span>
      </div>
    </div>

    <button (click)="state.executeStake()"
      class="btn-gold w-full py-4 rounded-xl text-[13px] font-bold tracking-widest uppercase shadow-md">
      {{ state.isWalletConnected() ? 'Lock Stake Assets' : 'Connect Wallet' }}
    </button>
  </div>
</div>
}
